// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"496":"b9b5f954","825":"41f4dab9","882":"28aea3ed"}[chunkId] + ".chunk.css");